import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconCropRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.432 4a1 1 0 0 1 1 1v9.11c0 .232.19.426.43.426h9.139a1 1 0 1 1 0 2h-1.808v2.465a1 1 0 1 1-2 0v-2.465h-5.33a2.429 2.429 0 0 1-2.431-2.426V8.563H5a1 1 0 1 1 0-2h2.432V5a1 1 0 0 1 1-1Zm1.705 3.565a1 1 0 0 1 1-1h3.624a2.429 2.429 0 0 1 2.43 2.426v3.776a1 1 0 0 1-2 0V8.99a.429.429 0 0 0-.43-.426h-3.624a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconCropRound);
export default Memo;
